import { IController, IHttpService } from 'angular';
import { inject, injectable } from '../../../../shared/utils/inject/inject';

@injectable
export class ExperimentLoaderController implements IController {
  public experimentsLoaded: boolean;
  @inject private $http: IHttpService;
  @inject private experimentManager: any;

  $onInit(): void {
    this.fetchExperiments()
      .catch(() => this.fetchExperiments())
      .then(response => {
        this.experimentManager.provider.setExperiments(response.data);
        this.experimentsLoaded = true;
      });
  }

  private fetchExperiments() {
    return this.$http.get(
      'https://www.wix.com/_api/wix-laboratory-server/laboratory/conductAllInScope',
      {
        params: {
          scope: 'bandsintown',
        },
        withCredentials: true,
      },
    );
  }
}
